import { render, staticRenderFns } from "./PublicImagesOnly.vue?vue&type=template&id=3b5ec90a&"
import script from "./PublicImagesOnly.vue?vue&type=script&lang=js&"
export * from "./PublicImagesOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports